module.exports = __webpack_public_path__ + "img/aaa.ac739852.jpg";